import { useState } from 'react';

import { OnboardingState } from '../../../types/OnboardingState';
import { SupplierOnboardingRequestMessage } from '../../../types/SupplierOnboardingRequestMessage';
import { useToasts } from '../../cdl/Toast/useToasts';
import { translate } from '../../common/helpers/translate.helper';
import { useSendOnboarding } from '../hooks/useSendOnboarding';
import { useUpdateCustomerDocuments } from '../hooks/useUpdateCustomerDocuments';

import { SupplierOnboardingDocumentsModal } from './SupplierOnboardingDocumentsModal';

interface SupplierOnboardingRequestModalProps {
    offerId: string;
    customerId: string;
    onboarding: SupplierOnboardingRequestMessage | null;
    isOpen: boolean;
    onDismiss: () => void;
}

export const SupplierOnboardingRequestModal = ({
    offerId,
    customerId,
    onboarding: initialOnboarding,
    isOpen,
    onDismiss,
}: SupplierOnboardingRequestModalProps) => {
    const [onboarding, setOnboarding] = useState(initialOnboarding);
    const updateDocuments = useUpdateCustomerDocuments();
    const sendRequest = useSendOnboarding();
    const { addToast, addErrorToast } = useToasts();

    return (
        <SupplierOnboardingDocumentsModal
            isOpen={isOpen}
            title={translate('supplierOnboarding.modal.requestTitle')}
            emptyTitle={translate('supplierOnboarding.modal.request.emptyTitle')}
            emptyDescription={translate('supplierOnboarding.modal.request.emptyDescription')}
            submitLabel={translate('supplierOnboarding.modal.requestSubmit')}
            companyId={customerId}
            documents={onboarding?.state === OnboardingState.DRAFT ? onboarding.customerDocuments : []}
            isSending={sendRequest.isPending}
            onPersist={async (fileIds) => {
                try {
                    setOnboarding(await updateDocuments.mutateAsync({ offerId, fileIds }));
                } catch {
                    addErrorToast(translate('supplierOnboarding.saveError'));
                }
            }}
            onSubmit={() =>
                sendRequest.mutate(offerId, {
                    onSuccess: () => {
                        addToast(translate('supplierOnboarding.requestSuccess'));
                        onDismiss();
                    },
                    onError: () => addErrorToast(translate('supplierOnboarding.requestError')),
                })
            }
            onDismiss={onDismiss}
        />
    );
};
